import { Reveal } from "./Reveal";
import { REPRESENT } from "../lib/data";

export default function WhoWeRepresent() {
  return (
    <section id="represent" className="mx-auto max-w-[1600px] px-6 sm:px-10 py-16 sm:py-32" data-testid="represent">
      <div className="flex items-end justify-between gap-6 mb-14">
        <Reveal>
          <div className="label mb-5">Who We Represent</div>
          <h2 className="font-sans font-semibold uppercase text-warm text-4xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-[-0.02em]">
            The next generation
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 lg:gap-6">
        {REPRESENT.map((r, i) => (
          <Reveal key={r.no} delay={(i % 2) * 0.08}>
            <div className="group relative overflow-hidden aspect-[16/10] bg-charcoal" data-cursor="hover" data-testid={`represent-${r.no}`}>
              <img
                src={r.image}
                alt={r.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover grayscale transition-all duration-[1200ms] ease-out group-hover:scale-105 group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
              <div className="absolute inset-0 p-6 sm:p-9 flex flex-col justify-between">
                <span className="label !text-warm/70">{r.no}</span>
                <div>
                  <h3 className="font-sans font-semibold uppercase text-warm text-3xl sm:text-5xl tracking-[-0.02em] leading-none">
                    {r.title}
                  </h3>
                  <p className="mt-3 max-w-sm text-silver text-sm sm:text-base font-light leading-relaxed">
                    {r.copy}
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
